export default __webpack_public_path__ + "static/media/image-cover.127c969f.jpg";